module.exports = __webpack_public_path__ + "7dc4d79241b8d72acad38f96f00a26fd.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/186.png
// module id = 1769
// module chunks = 2